export default __webpack_public_path__ + "static/media/opensans-bold-webfont.fb978026.woff";